import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPopupModalConfirm = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 12,
		cy: 12,
		r: 12,
		fill: "#FFB800"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M18 8L10.4801 15.292C10.0789 15.6811 9.43667 15.6658 9.05443 15.2581L6 12",
		stroke: "white",
		strokeWidth: 1.5,
		strokeLinecap: "square"
	})]
});
export default SvgPopupModalConfirm;
